import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  Injector, ViewChild,
} from '@angular/core';
import {forkJoin, Observable, of, takeUntil} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {FlickingError} from "@egjs/ngx-flicking";
import {PlayerContainer} from "../../player/player.container";


@Component({
  selector: 'app-flicking',
  template:`
    <div #component>
      <template #playercontainer></template>
      <ngx-flicking #flk [options]=options>
        <app-flicking-item flicking-panel *ngFor="let page of pages" class="flicking-panel"
          [setParentPlayer]="this"
          [setEditMode]="editMode"
          [setPage]="page">
        </app-flicking-item>
      </ngx-flicking>
    </div>
  `,
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlickingComponent extends PlayerContainer {
  options;
  pages: any;
  index = 0;
  updateIndex = 0;

  @ViewChild('flk', {static: true} ) flk;

  constructor(protected  injector: Injector) {
    super(injector);

  }

  getPage(): Observable<any> {
    this.pages = this.data.Flicking[0].Page;
    const page = this.pages[0];
    let player = page.Player[0];
    return of(player);
  }

  load(playerObject: any): Observable<any> {
    let self;
    let initialized = false;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        this.scaleX = this.parentPlayer.scaleX;
        this.scaleY = this.parentPlayer.scaleY;
        this.options = { align: 'prev' };
        this.options.horizontal = this.data.Flicking[0].$.vertical=='0';
        this.pages = this.data.Flicking[0].Page;
        this.updateIndex = 0;

        if (this.pages==null || this.pages.length==0) {
          this.showMsg(this.playerObject.$.label, 'Flicking is empty');
          this.changeDetectorRef.detectChanges();
          return of('a');
        } else {
          this.showMsg(null, null);

          if (this.editMode) {
            this.display(true);
            return this.showPage();
          }

          this.changeDetectorRef.detectChanges();
          const list = [];
          this.pages.forEach(page => {
            list.push(page.$obs);
          })
          return forkJoin(list);
        }
      }),
      catchError(err => this.logError(err)),
      switchMap( a=> of(self)),
      takeUntil(this.finish$)
    )
  }

  loadAnimation() {
  }

  display(show) {
  }


  updatePanels() {
    this.updateIndex++
    if (this.updateIndex<this.pages.length) {
      return;
    }
    this.flk.moveTo(0).catch(err => {
      if (err instanceof FlickingError)
        return;
      throw err;
    });
    this.flk.resize();
  }


  onCommand(command, param): Observable<any> {
    if (this.pages.length==0) {
      return of(null);
    }

    const cmd = command.$.command;
    switch (cmd) {
      case 'firstPage':
        this.index=0;
        break;

      case 'prevPage':
        if (this.index>0) {
          this.index--;
        }
        break;

      case 'nextPage':
        if (this.index < this.pages.length-1) {
          this.index++;
        }
        break;

      case 'lastPage':
        this.index = this.pages.length-1;
        break;
    }

    this.flk.moveTo(this.index).catch(err => {
      if (err instanceof FlickingError)
        return;
      throw err;
    });

    return of('command');
  }

  destroy(): void {
    this.pages = null;
    super.destroy();
  }
}
